const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID;
const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET;
const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION;

if (typeof projectId === 'undefined') {
  throw new Error('Define NEXT_PUBLIC_SANITY_PROJECT_ID in .env file');
}

if (typeof dataset === 'undefined') {
  throw new Error('Define NEXT_PUBLIC_SANITY_DATASET in .env file');
}

if (typeof apiVersion === 'undefined') {
  throw new Error('Define NEXT_PUBLIC_SANITY_API_VERSION in .env file');
}

export const SANITY_PROJECT_ID = projectId;
export const SANITY_DATASET = dataset;
export const SANITY_API_VERSION = apiVersion;
